import React from 'react';
import { useTeamVisualResolver } from '../hooks/useTeamVisualResolver';
import TeamVisualChip from './leagueHome/TeamVisualChip';

export type CfbInlineTeamChipProps = {
  label: string;
  schoolId?: string | null;
  size?: 'sm' | 'md';
  showLabel?: boolean;
  className?: string;
};

const CfbInlineTeamChip: React.FC<CfbInlineTeamChipProps> = ({
  label,
  schoolId,
  size = 'sm',
  showLabel = false,
  className = '',
}) => {
  const resolveVisual = useTeamVisualResolver();
  const visual = resolveVisual({ label, schoolId });

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`.trim()} data-testid="cfb-inline-team-chip">
      <TeamVisualChip abbreviation={visual.initials} accentColor={visual.accentColor} size={size} />
      {showLabel ? (
        <span className="truncate text-sm text-secondary-200">{visual.displayName}</span>
      ) : null}
    </span>
  );
};

export default CfbInlineTeamChip;
